import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Icon } from "../../../datos";
import { Nav, NavMobile } from "../Menu";
import { FaBars, FaTimes, FaBriefcase } from "react-icons/fa";

export function Header() {
  const [navMobile, setNavMobile] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleVerVacantes = () => {
    navigate("/recursohumano");
    setTimeout(() => {
      const el = document.getElementById("vacantes");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 100);
  };

  return (
    <header
      className={`fixed z-50 w-full transition-all duration-300 ${
        scrolled
          ? "bg-[#0d125c] shadow-[0_4px_24px_rgba(13,18,92,0.5)] py-2"
          : "bg-[#151C84] py-3"
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 group flex-shrink-0">
            <div className="transition-transform duration-300 group-hover:scale-105">
              <Icon.LogoWhite className="h-10 sm:h-14 w-auto" />
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-4">
            <Nav />
            <button
              onClick={handleVerVacantes}
              className="flex items-center gap-2 px-4 py-2 text-white/80 hover:text-white text-sm font-semibold rounded-lg transition-all duration-200 hover:bg-white/10"
            >
              <FaBriefcase className="w-4 h-4" />
              Ver Vacantes
            </button>
            <Link
              to="/recursohumano/formulario"
              className="flex items-center gap-2 px-5 py-2.5 bg-[#C81416] hover:bg-[#8c0e0f] text-white text-sm font-bold rounded-lg transition-all duration-300 shadow-[0_4px_14px_rgba(200,20,22,0.4)] hover:shadow-[0_4px_20px_rgba(200,20,22,0.6)] hover:-translate-y-0.5"
            >
              Únete al Equipo
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setNavMobile(!navMobile)}
            className="lg:hidden p-2.5 rounded-lg transition-all duration-300 text-white hover:bg-white/10"
            aria-label="Toggle menu"
          >
            {navMobile ? <FaTimes className="w-5 h-5" /> : <FaBars className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation Drawer */}
      <div
        className={`lg:hidden absolute left-0 right-0 top-full transition-all duration-300 overflow-hidden ${
          navMobile ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="bg-[#0d125c] border-t border-white/10 shadow-xl">
          <NavMobile navMobile={navMobile} setNavMobile={setNavMobile} />
        </div>
      </div>
    </header>
  );
}
